<template>
    <div>
    <div class="newsticker-box">
      <ul v-bind:style="styles">
        <li v-for="item in list"
            :key="item.id">
          {{item.title['zh-cn']}}
        </li>
      </ul>
    </div>
    </div>
</template>
<script>
import { getNewsTicker } from '@/api';

export default {
  name: 'newsticker',
  mounted() {
    getNewsTicker(this.$store.state.code).then((res) => {
      this.list = res.news;
    });
    setInterval(() => {
      if (this.position === this.list.length - 1) {
        this.styles.transition = 'none';
        this.position = -1;
        const str = 'translateY(30px)';
        this.styles.transform = str;
      } else {
        this.moveUp();
      }
    }, 3000);
  },
  data() {
    return {
      language: 'zh',
      list: [],
      position: 0,
      styles: {
        transform: `translateY(${this.position * 30}px)`,
      },
    };
  },
  computed: {
    isLast() {
      return (this.list.length - this.position > 3);
    },
    isFirst() {
      return !(this.position < 1);
    },
  },
  methods: {
    openUrl(url) {
      window.open(url);
    },
    moveUp() {
      this.position += 1;
      const str = `translateY(-${this.position * 30}px)`;
      this.styles.transition = 'all 0.5s';
      this.styles.transform = str;
    },
    moveDown() {
      console.log(this.position);
      if (this.position > 0) {
        this.position -= 1;
        const str = `translateY(-${this.position * 26}px)`;
        this.styles.transform = str;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.newsticker{
    &-box {
    height: 30px;
    width: 100%;
    margin: 0px;
    padding: 0px;
    overflow: hidden;
    ul {
      width: 90%;
      margin: 0px 10px;
      padding: 0px;
      transition: all 0.5s;
      li {
        font-size: 10px;
        line-height: 30px;
        margin-top: 1px;
        color: #e7e5e5;
        text-align: left;
        background-color: #000000ad;
        cursor: pointer;
        list-style-type:none;
      }
      li:hover {
        color: white;
      }
    }
  }
}
</style>
